<template>
  <div class="services-page">
    <section class="services-hero">
      <div class="hero-background">
        <img src="../assets/英语.png" alt="Services Background" class="hero-bg-img" />
        <div class="hero-overlay"></div>
      </div>
      <div class="container">
        <div class="services-hero-content">
          <h1>Our Services</h1>
          <p>Discover how our AI-powered tools can transform your photos</p>
        </div>
      </div>
    </section>

    <section class="download-cta">
      <div class="container">
        <h2 class="section-title">Download today and start your journey</h2>
        <p class="section-subtitle">Available on Android & iOS</p>
        
        <div class="download-badges">
          <a href="#" class="download-badge">
            <div class="badge-placeholder">
              <span class="badge-icon">📱</span>
              <span class="badge-text">App Store</span>
            </div>
          </a>
          <a href="#" class="download-badge">
            <div class="badge-placeholder">
              <span class="badge-icon">🤖</span>
              <span class="badge-text">Google Play</span>
            </div>
          </a>
        </div>
        
        <div class="app-screens-showcase">
          <div class="screen-carousel">
            <img src="../assets/英语.png" alt="App Screen" class="screen-image" />
            <img src="../assets/英语2.png" alt="App Screen" class="screen-image" />
            <img src="../assets/英语3.png" alt="App Screen" class="screen-image" />
            <img src="../assets/英语4.png" alt="App Screen" class="screen-image" />
            <img src="../assets/英语5.png" alt="App Screen" class="screen-image" />
          </div>
        </div>
      </div>
    </section>

    <section class="services-intro">
      <div class="container">
        <p>
          Our Photo Enhancer - AI Upscaler service uses cutting-edge artificial intelligence technology to improve the quality of your photos.
          Whether it's blurry photos, low-resolution images, or old family photos, we can help you restore and enhance them,
          making them look clear and vivid, as if they were taken with the latest high-end camera.
        </p>
      </div>
    </section>

    <section class="services-grid">
      <div class="container">
        <div class="services-list">
          <div class="service-card">
            <div class="service-icon">✨</div>
            <h3>Photo Enhancement</h3>
            <p>Enhance the quality of your photos with our AI-powered technology. Improve colors, contrast, and sharpness with just one click.</p>
            <span class="learn-more">Learn more</span>
          </div>
          
          <div class="service-card">
            <div class="service-icon">🔍</div>
            <h3>AI Upscaling</h3>
            <p>Increase the resolution of your images without losing quality. Our AI upscaler can enlarge your photos up to 4x their original size.</p>
            <span class="learn-more">Learn more</span>
          </div>
          
          <div class="service-card">
            <div class="service-icon">🖼️</div>
            <h3>Image Enlarger</h3>
            <p>Convert small images to larger ones without pixelation. Perfect for printing photos or creating large displays from small originals.</p>
            <span class="learn-more">Learn more</span>
          </div>
        </div>
      </div>
    </section>

    <section class="case-studies">
      <div class="container">
        <h2>Success Stories</h2>
        <p class="section-subtitle">See how our AI enhancement technology has transformed photos</p>
        
        <div class="case-studies-grid">
          <div class="case-study">
            <div class="case-image">
              <img src="../assets/英语.png" alt="Portrait Enhancement" />
            </div>
            <div class="case-content">
              <h3>Portrait Enhancement</h3>
              <p>A professional photographer needed to restore an old portrait photo for a client's family album. Our AI technology was able to enhance the details, improve clarity, and restore colors that had faded over time.</p>
              <ul class="case-features">
                <li>Facial detail restoration</li>
                <li>Color correction</li>
                <li>Background noise removal</li>
              </ul>
            </div>
          </div>
          
          <div class="case-study reverse">
            <div class="case-image">
              <img src="../assets/英语3.png" alt="Landscape Enhancement" />
            </div>
            <div class="case-content">
              <h3>Landscape Enhancement</h3>
              <p>A travel blogger had taken photos during a foggy day at a mountain range. Using our enhancement technology, we were able to reduce the fog effect, bring out the details of the mountains, and enhance the colors of the landscape.</p>
              <ul class="case-features">
                <li>Weather effect reduction</li>
                <li>Detail enhancement</li>
                <li>Color vibrancy improvement</li>
              </ul>
            </div>
          </div>
          
          <div class="case-study">
            <div class="case-image">
              <img src="../assets/英语5.png" alt="Family Photo Restoration" />
            </div>
            <div class="case-content">
              <h3>Family Photo Restoration</h3>
              <p>A client had an old family photo from the 1950s that was damaged and faded. Our AI technology was able to restore the photo, fix scratches and tears, and bring back the colors, preserving a precious family memory.</p>
              <ul class="case-features">
                <li>Damage repair</li>
                <li>Age restoration</li>
                <li>Detail recovery</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 添加 App 功能展示部分 -->
    <section class="app-features">
      <div class="container">
        <h2>App Features</h2>
        <p class="section-subtitle">Discover what our Photo Enhancer app can do</p>
        
        <div class="features-container">
          <div class="features-text">
            <div class="feature-item">
              <div class="feature-icon">🔍</div>
              <div class="feature-content">
                <h3>Smart Photo Analysis</h3>
                <p>Our AI analyzes your photos to identify areas that need enhancement, from faces to landscapes.</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon">✨</div>
              <div class="feature-content">
                <h3>One-Tap Enhancement</h3>
                <p>With just one tap, transform your photos with our AI-powered enhancement technology.</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon">🔄</div>
              <div class="feature-content">
                <h3>Before/After Comparison</h3>
                <p>Easily compare your original and enhanced photos with our interactive slider view.</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon">⚙️</div>
              <div class="feature-content">
                <h3>Advanced Controls</h3>
                <p>Fine-tune enhancement parameters like sharpness, color, and noise reduction to your preference.</p>
              </div>
            </div>
            
            <div class="feature-item">
              <div class="feature-icon">📱</div>
              <div class="feature-content">
                <h3>Batch Processing</h3>
                <p>Enhance multiple photos at once to save time and effort.</p>
              </div>
            </div>
          </div>
          
          <div class="features-screens">
            <div class="screen-carousel">
              <img src="../assets/英语.png" alt="App Screen" class="screen-image" />
              <img src="../assets/英语2.png" alt="App Screen" class="screen-image" />
              <img src="../assets/英语3.png" alt="App Screen" class="screen-image" />
              <img src="../assets/英语4.png" alt="App Screen" class="screen-image" />
              <img src="../assets/英语5.png" alt="App Screen" class="screen-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesPage',
  data() {
    return {
      services: [
        {
          title: 'Photo Enhancement',
          description: 'Restore and enhance blurry images to HD quality using AI photo sharpener.',
          details: 'Our AI-powered enhancement technology can recover details from low-quality photos and make them look crisp and clear.',
          icon: 'enhance'
        },
        {
          title: 'AI Upscaling',
          description: 'Upgrade old or phone photos to look like they were taken with the latest devices, converting blurry photos to crisp digital images.',
          details: 'Our upscaling technology can increase the resolution of your photos while maintaining and enhancing details.',
          icon: 'upscale'
        },
        {
          title: 'Image Enlarger',
          description: 'Restore compressed, damaged, or low-resolution photos with free smart repair technology, including deblurring, for high-resolution, HD results.',
          details: 'Enlarge your photos without losing quality, perfect for printing or displaying on large screens.',
          icon: 'upscaler'
        },
        {
          title: 'Image Enhancer',
          description: 'Easily fix damaged photos with scratches and creases; remove noise and pixels from photos while preserving low-resolution images.',
          details: 'Our enhancer can fix various issues in your photos, from noise reduction to scratch removal.',
          icon: 'enhancer'
        }
      ]
    }
  },
  methods: {
    getIconElement(iconName) {
      switch (iconName) {
        case 'enhance':
          return '🔍';
        case 'upscale':
          return '📱';
        case 'upscaler':
          return '🖼️';
        case 'enhancer':
          return '✨';
        case 'quality':
          return '⚡';
        default:
          return '📷';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 添加防止溢出的样式 */
.services-page {
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
}

.services-hero {
  position: relative;
  padding: 150px 0;
  color: white;
  text-align: center;
  overflow: hidden;
  
  .hero-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    
    .hero-bg-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.5));
    }
  }
  
  h1 {
    font-size: 3.5rem;
    font-weight: 800;
    margin-bottom: 20px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  }
  
  p {
    font-size: 1.3rem;
    max-width: 700px;
    margin: 0 auto;
    opacity: 0.9;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  }
}

.download-cta {
  padding: 80px 0;
  background-color: #f8f9fa;
  
  .section-title {
    text-align: center;
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: #333;
  }
  
  .section-subtitle {
    text-align: center;
    font-size: 1.1rem;
    color: var(--text-light);
    max-width: 700px;
    margin: 0 auto 50px;
  }
  
  .download-badges {
    display: flex;
    justify-content: center;
    gap: 15px;
    
    .download-badge {
      text-decoration: none;
      transition: transform 0.3s ease;
      
      &:hover {
        transform: translateY(-5px);
      }
      
      .badge-placeholder {
        display: flex;
        align-items: center;
        background: #333;
        color: white;
        padding: 10px 20px;
        border-radius: 8px;
        
        .badge-icon {
          font-size: 24px;
          margin-right: 10px;
        }
        
        .badge-text {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
  
  .app-screens-showcase {
    margin-top: 50px;
    
    .screen-carousel {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      height: 600px;
      
      .screen-image {
        position: absolute;
        width: 280px;
        height: 550px;
        object-fit: cover;
        border-radius: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        transition: all 0.5s ease;
        
        &:nth-child(1) {
          transform: translateX(-120px) scale(0.85);
          z-index: 1;
          opacity: 0.7;
        }
        
        &:nth-child(2) {
          transform: translateX(-60px) scale(0.9);
          z-index: 2;
          opacity: 0.8;
        }
        
        &:nth-child(3) {
          transform: translateX(0) scale(1);
          z-index: 3;
          opacity: 1;
        }
        
        &:nth-child(4) {
          transform: translateX(60px) scale(0.9);
          z-index: 2;
          opacity: 0.8;
        }
        
        &:nth-child(5) {
          transform: translateX(120px) scale(0.85);
          z-index: 1;
          opacity: 0.7;
        }
      }
    }
  }
}

.services-intro {
  padding: 60px 0;
  text-align: center;
  
  p {
    font-size: 1.2rem;
    color: #666;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.8;
  }
}

.services-grid {
  padding: 80px 0;
  background-color: #f8f9fa;
  
  .services-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    
    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  
  .service-card {
    background-color: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    }
    
    .service-icon {
      font-size: 36px;
      margin-bottom: 20px;
    }
    
    h3 {
      font-size: 20px;
      margin-bottom: 15px;
      color: var(--text-color);
    }
    
    p {
      color: var(--text-light);
      line-height: 1.6;
      margin-bottom: 20px;
    }
    
    .learn-more {
      display: inline-block;
      margin-top: 20px;
      color: var(--primary-color);
      font-weight: 600;
      cursor: pointer;
      transition: color 0.3s ease;
      
      &:hover {
        color: var(--primary-dark);
      }
    }
  }
}

.case-studies {
  padding: 100px 0;
  background-color: #f8f9fa;
  
  h2 {
    text-align: center;
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
  
  .section-subtitle {
    text-align: center;
    font-size: 1.1rem;
    color: var(--text-light);
    max-width: 700px;
    margin: 0 auto 50px;
  }
  
  .case-studies-grid {
    display: flex;
    flex-direction: column;
    gap: 80px;
  }
  
  .case-study {
    display: flex;
    align-items: center;
    gap: 50px;
    
    &.reverse {
      flex-direction: row-reverse;
    }
    
    .case-image {
      flex: 1;
      border-radius: var(--border-radius);
      overflow: hidden;
      box-shadow: var(--shadow);
      
      img {
        width: 100%;
        height: 500px;
        object-fit: cover;
        transition: transform 0.5s ease;
        
        &:hover {
          transform: scale(1.03);
        }
      }
    }
    
    .case-content {
      flex: 1;
      
      h3 {
        font-size: 1.8rem;
        margin-bottom: 20px;
        color: var(--text-color);
      }
      
      p {
        font-size: 1.1rem;
        line-height: 1.8;
        color: var(--text-light);
        margin-bottom: 25px;
      }
      
      .case-features {
        list-style: none;
        
        li {
          position: relative;
          padding-left: 30px;
          margin-bottom: 15px;
          font-size: 1.05rem;
          color: var(--text-color);
          
          &:before {
            content: '✓';
            position: absolute;
            left: 0;
            color: var(--primary-color);
            font-weight: bold;
          }
        }
      }
    }
  }
}

.app-features {
  padding: 100px 0;
  
  h2 {
    text-align: center;
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
  
  .section-subtitle {
    text-align: center;
    font-size: 1.1rem;
    color: var(--text-light);
    max-width: 700px;
    margin: 0 auto 50px;
  }
  
  .features-container {
    display: flex;
    gap: 50px;
    align-items: center;
  }
  
  .features-text {
    flex: 1;
  }
  
  .feature-item {
    display: flex;
    margin-bottom: 30px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .feature-icon {
      font-size: 24px;
      margin-right: 20px;
      background: var(--primary-gradient);
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      flex-shrink: 0;
    }
    
    .feature-content {
      h3 {
        font-size: 1.2rem;
        margin-bottom: 10px;
        color: var(--text-color);
      }
      
      p {
        font-size: 1rem;
        color: var(--text-light);
        line-height: 1.6;
      }
    }
  }
  
  .features-screens {
    flex: 1;
    position: relative;
    
    .screen-carousel {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      height: 600px;
      
      .screen-image {
        position: absolute;
        width: 280px;
        height: 550px;
        object-fit: cover;
        border-radius: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        transition: all 0.5s ease;
        
        &:nth-child(1) {
          transform: translateX(-120px) scale(0.85);
          z-index: 1;
          opacity: 0.7;
        }
        
        &:nth-child(2) {
          transform: translateX(-60px) scale(0.9);
          z-index: 2;
          opacity: 0.8;
        }
        
        &:nth-child(3) {
          transform: translateX(0) scale(1);
          z-index: 3;
          opacity: 1;
        }
        
        &:nth-child(4) {
          transform: translateX(60px) scale(0.9);
          z-index: 2;
          opacity: 0.8;
        }
        
        &:nth-child(5) {
          transform: translateX(120px) scale(0.85);
          z-index: 1;
          opacity: 0.7;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .services-page {
    .download-cta {
      .app-screens-showcase {
        .screen-carousel {
          height: 500px;
          
          .screen-image {
            width: 220px;
            height: 450px;
            
            &:nth-child(1) {
              transform: translateX(-80px) scale(0.85);
            }
            
            &:nth-child(2) {
              transform: translateX(-40px) scale(0.9);
            }
            
            &:nth-child(4) {
              transform: translateX(40px) scale(0.9);
            }
            
            &:nth-child(5) {
              transform: translateX(80px) scale(0.85);
            }
          }
        }
      }
    }

    .case-studies {
      .case-study {
        flex-direction: column;
        
        &.reverse {
          flex-direction: column;
        }
        
        .case-image {
          width: 100%;
          
          img {
            height: 400px;
          }
        }
      }
    }

    .app-features {
      .features-screens {
        margin-top: 50px;
        
        .screen-carousel {
          height: 500px;
          
          .screen-image {
            width: 220px;
            height: 450px;
            
            &:nth-child(1) {
              transform: translateX(-80px) scale(0.85);
            }
            
            &:nth-child(2) {
              transform: translateX(-40px) scale(0.9);
            }
            
            &:nth-child(4) {
              transform: translateX(40px) scale(0.9);
            }
            
            &:nth-child(5) {
              transform: translateX(80px) scale(0.85);
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .services-page {
    .services-grid {
      .service-card {
        .service-icon {
          margin-right: 0;
          margin-bottom: 20px;
          text-align: center;
        }
      }
    }

    .app-features {
      .features-screens {
        .screen-carousel {
          overflow: hidden; /* 确保轮播不会溢出 */
          
          .screen-image {
            width: 180px;
            height: 350px;
            
            &:nth-child(1), &:nth-child(5) {
              display: none;
            }
            
            &:nth-child(2) {
              transform: translateX(-50px) scale(0.9);
            }
            
            &:nth-child(4) {
              transform: translateX(50px) scale(0.9);
            }
          }
        }
      }
    }
  }
}
</style> 